import styled from 'styled-components'

export const OvelayContainer = styled.div`
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: ${props => props.active ? '19' : '99'};
    opacity: ${props => props.active ? '.5' : '0'};
    visibility: ${props => props.active ? 'visible' : 'hidden'};
    background: #000;
`
